import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO } from "../../../shared/src/codecs/types/formIO";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { string } from "../../../shared/src/codecs/types/string";
import { union } from "../../../shared/src/codecs/types/union";
import { integer } from "../../../shared/src/codecs/types/integer";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { longString } from "../../../shared/src/codecs/types/longString";
import { literal } from "../../../shared/src/codecs/types/literal";
import { boolean } from "../../../shared/src/codecs/types/boolean";

export const ListingValuationAction = () => union([
    literal("start_enrichment"),
    literal("retry_failed_steps"),
    literal("recompute"),
    literal("amend_price"),
    literal("adopt_fact"),
    literal("mark_sent"),
]);

export const ValuationEditableFact = () => union([
    literal("Bedrooms"),
    literal("Bathrooms"),
    literal("Floor area"),
]);

export type TValuationEditableFact = TTypeOfCodec<ReturnType<typeof ValuationEditableFact>>;


export const ListingValuationActionFormIO = formIO(
    required({
        listing_id: uuid(),
        action: ListingValuationAction(),
        amend_price_pence: union([nullCodec(), integer()]),
        amend_reason: union([nullCodec(), longString()]),
        fact_field: union([nullCodec(), ValuationEditableFact()]),
    }),
    required({
        outcome: string(),
        blocked: boolean(),
    }),
);

export type TListingValuationActionFormIOCodec = typeof ListingValuationActionFormIO;
export type TListingValuationActionFormIO = TTypeOfCodec<TListingValuationActionFormIOCodec>;
export type TListingValuationActionName = TTypeOfCodec<ReturnType<typeof ListingValuationAction>>;
